/**
 * Tipo canônico de Appointment de evolução de paciente.
 * Espelha PRONTO_ATENDIMENTO_TYPE_SERVICE — code FHIR v2-0276.
 */
export const EVOLUTION_TYPE_SERVICE = "EVOLUTION";
export const EVOLUTION_TYPE_TEXT = "Evolução";
export const EVOLUTION_APPOINTMENT_TYPE_SYSTEM =
  "http://terminology.hl7.org/CodeSystem/v2-0276";
/** Duração padrão do Slot (igual ao Pronto Atendimento). */
export const EVOLUTION_SLOT_DURATION_MINUTES = 30;
/** Note FHIR (Appointment e Encounter): evolução sem o paciente presente. */
export const EVOLUTION_NOTE =
  "Evolução do paciente sem presença do paciente";
